/** 路由路径常量，便于统一修改与引用 */
export const ROUTES = {
  HOME: "/home",
  PERSONAL_TOKEN: "/personal-token",
  SUBSCRIBE: "/subscribe",
  USER_AGREEMENT:"/user-agreement",
  PRIVACY_POLICY :"/privacy-policy",
  LOGIN: "/login",
  NOT_FOUND: "/404",
} as const;

/** 接口业务状态码：成功 */
export const API_SUCCESS_CODE = "0000";


export const  memberLevelMap: Record<number, string> = {
    0: 'subscribe.free_member',
    1: 'subscribe.basic_member',
    2: 'subscribe.standard_member',
    3: 'subscribe.senior_member'
  }
